<template>
  <div class="g-wrap">
    <Banner :click="bannerClickHandler"></Banner>
    <Loading v-if="!dataLoaded"></Loading>
    <template v-else>
      <section class="m-book clearfix" @click="bookClickHandler">
        <img :src="questionWrapper.bookWrapper.book.imageUrl" alt="书籍封面" class="m-book__cover">
        <h2 class="m-book__name">{{questionWrapper.bookWrapper.book.title}}</h2>
        <div class="m-book__author">
          <span v-for="(author, index) in questionWrapper.bookWrapper.authors" :key="author.authorId">
            {{index > 0 ? `、${author.name}` : author.name}}
          </span>
        </div>
        <div class="m-book__reader">{{formatNumber(questionWrapper.bookWrapper.readerCount)}}人在读</div>
      </section>
      <section class="m-question clearfix">
        <div class="m-question__avatar" 
          :class="{auth: questionWrapper.userWrapper.user.authUser}"
          :style="{backgroundImage: `url(${questionWrapper.userWrapper.user.imageUrl || 'https://yuedust.yuedu.126.net/snail_st/static/images/share/account_avatar_big@2x.png'})`}"
        >
        </div>
        <h2 class="m-question__title">{{questionWrapper.question.question}}</h2>
        <div class="m-question__quote">{{questionWrapper.question.markText}}</div>
      </section>
      <section class="m-answers clearfix">
        <div @click="answerClickHandler">
          <div class="m-answers__count">共{{formatNumber(answerCount)}}个回答</div>
          <div class="m-answer clearfix">
            <div v-if="!answers.length" class="m-answer__empty"></div>
            <template v-else>
              <div class="m-answer__item" v-for="(answer, index) in answers" :key="index">
                <div class="m-user clearfix">
                  <div class="m-user__avatar"
                    :style="{backgroundImage: `url(${answer.userWrapper.user.imageUrl || 'https://yuedust.yuedu.126.net/snail_st/static/images/share/account_avatar_big@2x.png'})`}"
                    :class="{auth: answer.userWrapper.user.authUser}"
                  >
                  </div>
                  <span class="m-user__follow" @click="followClickHandler">关注</span>
                  <div class="m-user__name">{{answer.userWrapper.user.nickName}}</div>
                  <div class="m-user__desc">{{answer.userWrapper.user.introduction}}</div>
                  </div>
                  <div v-for="(item, index) in answer.items" :key="index">
                    <img v-if="item.resourceType === 'Image'" :src="item.imageUrl" alt="" class="m-answer__img">
                    <p v-else class="m-answer__text">{{item.text}}</p>
                  </div>
                  <div class="m-answer__info clearfix">
                      <span class="m-answer__time">{{formatTime(answer.answer.createTime)}}</span>
                      <span class="m-answer__praise" @click="praiseClickHandler">{{formatNumber(answer.answer.likeCount)}}</span>
                  </div>
                  <div v-if="answer.children" class="m-reply">
                    <div class="m-reply__title">共{{answer.answer.commentCount}}条回复</div>
                    <Reply :replys="answer.children" :count="answer.answer.commentCount" :getAllReplyLogHandler="getAllReplyLogHandler"></Reply>
                  </div>
                  <div v-if="index < 4" class="m-line"></div>
              </div>
            </template>
          </div>
        </div>
        <div v-if="answerCount > 1" class="m-answer__open" @click="getAllAnswerClickHandler">打开APP，查看全部回答</div>
      </section>
      <div class="m-goAnswer" @click="goAnswerHandler">打开APP，回答此问题</div>
      <Divider></Divider>
      <user-invite v-if="uuid" :uuid="uuid" :copyHandler="copyHandler"></user-invite>
      <Bottom :logHandler="downloadLogHandler"></Bottom>
    </template>
  </div>
</template>

<script>
import getEnvInfo from 'snail-env'
import Log from 'snail-log'
import {openAppSnail} from 'nw-app-snail'
import {setOrUpdate} from 'nw-share'
import parseUrl from '../../../js/utils/parseUrl.js'
import {format} from 'nw-toolkits/es/time-format'
import {customFormatNumber} from 'nw-toolkits/es/number-format'
import {trace} from 'snail-trace'

import Banner from '../../../vue-components/components/Banner'
import Loading from '../../../vue-components/components/Loading'
import Divider from '../../../vue-components/components/Divider'
import UserInvite from '../../../vue-components/components/UserInvite'
import Bottom from '../../../vue-components/components/Bottom'
import Reply from '../../../vue-components/components/Reply'

export default {
  name: 'question',
  components: {
    Banner,
    Loading,
    Divider,
    UserInvite,
    Bottom,
    Reply
  },
  data(){
    return {
      dataLoaded: false,
      questionId: '',
      uuid: getEnvInfo().env === 'online' ? 'ea692b2fe1da4eb0a295f8f4ab5b992e' : '479bcf687d0e4f369072c60681c0a2a6',
      questionWrapper: null,
      answers: [],
      answerCount: 0
    }
  },
  created(){
    //traceId上报
    trace();
    this.isSnail = navigator.userAgent.match(/NeteaseSnailReader[^/]*\/(\d[.\d]+).*\((.*);(.*)\)/i);
    const match = location.href.match(/\/question\/(\d+)/);
    if(match && match[1]){
      this.questionId = match[1];
      this.envInfo = getEnvInfo();
      const urlData = parseUrl();
      if(urlData && urlData.user){
        this.uuid = urlData.user;
      }
      if(this.isSnail){
        this.openApp();
      }
      this.log = new Log('h5');
      this.getDetail();
      this.getAnswers();
    }else{
      location.href = '/404';
    }
  },
  methods: {
    openApp(){
      openAppSnail({
        path: 'question',
        query: {
          questionId: this.questionId
        }
      })
    },
    bannerClickHandler(){
      this.log.sendLog('a4-6', ['question_page', 'open_app', this.questionId]);
      setTimeout(() => {
        this.openApp();
      }, 300);
    },
    bookClickHandler(){
      this.log.sendLog('a4-1', ['question_page', 'click_book', this.questionId]);
      setTimeout(() => {
        openAppSnail({
          path: 'bookdetail',
          query: {
            bookId: this.questionWrapper.bookWrapper.book.strBookId
          }
        })
      }, 300);
    },
    answerClickHandler(){
      this.log.sendLog('a4-7', ['question_page', 'click_answer', this.questionId]);
      setTimeout(() => {
        this.openApp();
      }, 300);
    },
    followClickHandler(){
      this.log.sendLog('a4-2', ['question_page', 'add_attention', this.questionId]);
    },
    praiseClickHandler(){
      this.log.sendLog('a4-3', ['question_page', 'add_likecount', this.questionId]);
    },
    getAllReplyLogHandler(){
      this.log.sendLog('a4-4', ['question_page', 'show_comments', this.questionId]);
    },
    getAllAnswerClickHandler(){
      this.log.sendLog('a4-8', ['question_page', 'view_all_answer', this.questionId]);
      setTimeout(() => {
        this.openApp();
      }, 300);
    },
    setShareConfig(){
      const shareConfig = {
          activityId: this.questionId,
          title: `关于${this.questionWrapper.bookWrapper.book.title}，${this.questionWrapper.question.question}`,
          description: `${this.formatNumber(this.questionWrapper.question.viewCount)}人在围观`,
          text: `关于${this.questionWrapper.bookWrapper.book.title}，${this.questionWrapper.question.question} @网易蜗牛读书` + location.href,
          picurl: this.questionWrapper.imageUrl ? this.questionWrapper.imageUrl + '?imageView&thumbnail=200y200' : 'https://easyreadfs.nosdn.127.net/web/trunk/1513149240838/snail_logo_60ptx3x.png',
          link: location.href
      }
      setOrUpdate(shareConfig);
    },
    async getDetail(){
      try {
        const response = await this.$http.jsonp(this.envInfo.pro + '/question/detail.jsonp', {
          params: {
            questionId: this.questionId
          }
        })
        if(response && response.body && response.body.code === 0){
          this.dataLoaded = true;
          // console.log(response.body);
          this.questionWrapper = response.body.questionWrapper;
          document.title = this.questionWrapper.question.question;
          this.setShareConfig();
        }else{
          console.log('获取用户详情错误');
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAnswers(){
      try {
        const response = await this.$http.jsonp(this.envInfo.pro + '/answer/list.jsonp', {
          params: {
            questionId: this.questionId,
            pageSize: 5,
            sortType: 'hot',
            childType: 1
          }
        })
        if(response && response.body && response.body.code === 0){
          // console.log(response.body);
          this.answers = response.body.answerWrappers;
          this.answerCount = response.body.totalCount;
          // this.setShareConfig();
        }else{
          console.log('获取用户详情错误');
        }
      } catch (error) {
        console.log(error);
      }
    },
    formatNumber(number){
      return customFormatNumber(number);
    },
    formatTime(time){
      return format(time);
    },
    copyHandler(){
      this.log.sendLog('a4-10', ['question_page', 'copy_invitecode_question', this.questionId])
    },
    goAnswerHandler(){
      this.log.sendLog('a4-5', ['question_page', 'answer', this.questionId]);
      setTimeout(() => {
        this.openApp();
      }, 300);
    },
    downloadLogHandler(){
      this.log.sendLog('a4-9', ['question_page', 'download', this.questionId]);
    }
  }
}
</script>

<style lang="scss">
  html,body{
    height: 100%;
  }
  body{
    background: #fff;
  }
  @import '../../../css/component/reset.css';
  @import '../style/question.css';
</style>

